<div
  class="loader"
  [class.padding]="withPadding"
  [class.loader--full]="full"
  [hidden]="!loading"
>
  <ion-spinner [name]="name" [color]="color"></ion-spinner>
</div>
